// import React, { useState, useEffect } from 'react';
// import { FaTimes, FaCar, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';

// const CarModal = ({ isOpen, onClose, onAdd, editingItem }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     carModel: '',
//     company: '',
//     pickupLocation: '',
//     dropoffLocation: '',
//     pickupDate: '',
//     dropoffDate: '',
//     carType: 'Economy',
//     price: ''
//   });

//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const pad = (num) => String(num).padStart(2, '0');
//   const formatDateTimeLocal = (date) => {
//     const d = new Date(date);
//     return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
//   };

//   useEffect(() => {
//     if (editingItem) {
//       setFormData(editingItem);
//     } else {
//       const now = new Date();
//       const defaultPickup = new Date(now.getTime() + 2 * 60 * 60 * 1000);
//       const defaultDropoff = new Date(now.getTime() + 26 * 60 * 60 * 1000);
//       setFormData({
//         name: '',
//         carModel: '',
//         company: '',
//         pickupLocation: '',
//         dropoffLocation: '',
//         pickupDate: formatDateTimeLocal(defaultPickup),
//         dropoffDate: formatDateTimeLocal(defaultDropoff),
//         carType: 'Economy',
//         price: ''
//       });
//     }
//     setErrors({});
//   }, [editingItem, isOpen]);

//   const validateForm = () => {
//     const newErrors = {};
    
//     if (!formData.name.trim()) newErrors.name = 'Rental name is required';
//     if (!formData.carModel.trim()) newErrors.carModel = 'Car model is required';
//     if (!formData.company.trim()) newErrors.company = 'Rental company is required';
//     if (!formData.pickupLocation.trim()) newErrors.pickupLocation = 'Pickup location is required';
//     if (!formData.dropoffLocation.trim()) newErrors.dropoffLocation = 'Drop-off location is required';
//     if (!formData.pickupDate) newErrors.pickupDate = 'Pickup date is required';
//     if (!formData.dropoffDate) newErrors.dropoffDate = 'Drop-off date is required';
//     if (!formData.price.trim()) newErrors.price = 'Price is required';
    
//     // Validate drop-off is after pickup
//     if (formData.pickupDate && formData.dropoffDate) {
//       const pickupDate = new Date(formData.pickupDate);
//       const dropoffDate = new Date(formData.dropoffDate);
//       if (pickupDate >= dropoffDate) {
//         newErrors.dropoffDate = 'Drop-off date must be after pickup date';
//       }
//     }
    
//     // Validate price format
//     if (formData.price && !/^\$?\d+(\.\d{2})?$/.test(formData.price)) {
//       newErrors.price = 'Please enter a valid price (e.g., $45 or 45)';
//     }
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) {
//       return;
//     }
    
//     setIsSubmitting(true);
    
//     try {
//       // Simulate API call delay
//       await new Promise(resolve => setTimeout(resolve, 500));
      
//       onAdd(formData);
//       onClose();
//     } catch (error) {
//       console.error('Error submitting car rental:', error);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleInputChange = (field, value) => {
//     setFormData(prev => ({ ...prev, [field]: value }));
//     // Clear error when user starts typing
//     if (errors[field]) {
//       setErrors(prev => ({ ...prev, [field]: '' }));
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 !m-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md p-4  animate-fadeIn">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] flex flex-col transform transition-all duration-300 scale-100">
//         {/* Enhanced Header */}
//         <div className="bg-gradient-to-r from-orange-600 via-amber-700 to-yellow-700 p-8 rounded-t-2xl relative overflow-hidden">
//           <div className="absolute inset-0 bg-black bg-opacity-10"></div>
//           <div className="relative flex items-center justify-between">
//             <div className="flex items-center space-x-4">
//               <div className="bg-white bg-opacity-20 p-3 rounded-xl backdrop-blur-sm border border-white border-opacity-30">
//                 <FaCar className="h-7 w-7 text-white" />
//               </div>
//               <div>
//                 <h3 className="text-2xl font-display font-bold text-white">
//                   {editingItem ? 'Edit Car Rental' : 'Add New Car Rental'}
//                 </h3>
//                 <p className="text-orange-100 text-lg">Complete car rental service details</p>
//               </div>
//             </div>
//             <button
//               onClick={onClose}
//               className="text-white hover:bg-white hover:bg-opacity-20 p-3 rounded-xl transition-all duration-200 hover:scale-105"
//             >
//               <FaTimes className="h-6 w-6" />
//             </button>
//           </div>
//         </div>

//         <div className="flex-1 overflow-y-auto bg-gray-50">
//           <form id="car-form" onSubmit={handleSubmit} className="p-8 space-y-8">
            

//             {/* Location & Timing Section */}
//             <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
//               <h4 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
//                 <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
//                 Location & Timing
//               </h4>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Pickup Location *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="text"
//                       value={formData.pickupLocation}
//                       onChange={(e) => handleInputChange('pickupLocation', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all duration-200 ${
//                         errors.pickupLocation ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                       placeholder="e.g., JFK Airport"
//                     />
//                     {errors.pickupLocation && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.pickupLocation && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.pickupLocation}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Drop-off Location *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="text"
//                       value={formData.dropoffLocation}
//                       onChange={(e) => handleInputChange('dropoffLocation', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all duration-200 ${
//                         errors.dropoffLocation ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                       placeholder="e.g., Downtown Office"
//                     />
//                     {errors.dropoffLocation && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.dropoffLocation && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.dropoffLocation}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Pickup Date & Time *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="datetime-local"
//                       value={formData.pickupDate}
//                       onChange={(e) => handleInputChange('pickupDate', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all duration-200 ${
//                         errors.pickupDate ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                     />
//                     {errors.pickupDate && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.pickupDate && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.pickupDate}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Drop-off Date & Time *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="datetime-local"
//                       value={formData.dropoffDate}
//                       onChange={(e) => handleInputChange('dropoffDate', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all duration-200 ${
//                         errors.dropoffDate ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                     />
//                     {errors.dropoffDate && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.dropoffDate && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.dropoffDate}
//                     </p>
//                   )}
//                 </div>
//               </div>
//             </div>

            
//           </form>
//         </div>
//         {/* Enhanced Footer */}
//         <div className="flex-shrink-0 bg-white border-t border-gray-200 p-8">
//           <div className="flex flex-col sm:flex-row gap-4">
//             <button
//               type="submit"
//               form="car-form"
//               disabled={isSubmitting}
//               className="flex-1 bg-gradient-to-r from-orange-600 via-amber-700 to-yellow-700 text-white py-4 px-8 rounded-xl font-semibold text-lg hover:from-orange-700 hover:via-amber-800 hover:to-yellow-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-lg flex items-center justify-center space-x-2"
//             >
//               {isSubmitting ? (
//                 <>
//                   <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
//                   <span>Processing...</span>
//                 </>
//               ) : (
//                 <>
//                   <FaCheckCircle className="h-5 w-5" />
//                   <span>{editingItem ? 'Update Car Rental' : 'Add Car Rental to Booking'}</span>
//                 </>
//               )}
//             </button>
//             <button
//               onClick={onClose}
//               disabled={isSubmitting}
//               className="flex-1 bg-gray-100 text-gray-700 py-4 px-8 rounded-xl font-semibold text-lg hover:bg-gray-200 transition-all duration-300 border border-gray-300 hover:border-gray-400 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
//             >
//               <FaTimes className="h-5 w-5" />
//               <span>Cancel</span>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CarModal;

import React, { useState, useEffect } from 'react';
import { FaTimes, FaCar, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';

const sampleCars = [
  { id: 1, name: 'Toyota Corolla', company: 'Hertz', carType: 'Economy', price: '45' },
  { id: 2, name: 'BMW 3 Series', company: 'Avis', carType: 'Luxury', price: '120' },
  { id: 3, name: 'Honda Civic', company: 'Enterprise', carType: 'Economy', price: '50' },
  { id: 4, name: 'Mercedes C-Class', company: 'Sixt', carType: 'Luxury', price: '130' },
];

const CarModal = ({ isOpen, onClose, onAdd, editingItem }) => {
  const [formData, setFormData] = useState({
    pickupLocation: '',
    dropoffLocation: '',
    pickupDate: '',
    dropoffDate: '',
  });

  const [selectedCar, setSelectedCar] = useState(null);
  const [availableCars, setAvailableCars] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searching, setSearching] = useState(false);

  const pad = (num) => String(num).padStart(2, '0');
  const formatDateTimeLocal = (date) => {
    const d = new Date(date);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  useEffect(() => {
    if (editingItem) {
      setFormData({
        pickupLocation: editingItem.pickupLocation,
        dropoffLocation: editingItem.dropoffLocation,
        pickupDate: editingItem.pickupDate,
        dropoffDate: editingItem.dropoffDate,
      });
      setSelectedCar(editingItem);
    } else {
      const now = new Date();
      setFormData({
        pickupLocation: '',
        dropoffLocation: '',
        pickupDate: formatDateTimeLocal(new Date(now.getTime() + 2 * 60 * 60 * 1000)),
        dropoffDate: formatDateTimeLocal(new Date(now.getTime() + 26 * 60 * 60 * 1000)),
      });
      setSelectedCar(null);
    }
    setAvailableCars([]);
    setErrors({});
  }, [editingItem, isOpen]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.pickupLocation.trim()) newErrors.pickupLocation = 'Pickup location is required';
    if (!formData.dropoffLocation.trim()) newErrors.dropoffLocation = 'Drop-off location is required';
    if (!formData.pickupDate) newErrors.pickupDate = 'Pickup date is required';
    if (!formData.dropoffDate) newErrors.dropoffDate = 'Drop-off date is required';
    if (formData.pickupDate && formData.dropoffDate) {
      if (new Date(formData.pickupDate) >= new Date(formData.dropoffDate)) {
        newErrors.dropoffDate = 'Drop-off date must be after pickup date';
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSearch = () => {
    if (!validateForm()) return;

    setSearching(true);
    // Simulate API call
    setTimeout(() => {
      // For demo, just return all sample cars
      setAvailableCars(sampleCars);
      setSearching(false);
    }, 500);
  };

  const handleSelectCar = (car) => {
    setSelectedCar(car);
  };

  const handleSubmit = async () => {
    if (!selectedCar) {
      alert('Please select a car first');
      return;
    }
    setIsSubmitting(true);
    try {
      const finalData = {
        ...formData,
        ...selectedCar,
      };
      await new Promise((resolve) => setTimeout(resolve, 500)); // simulate API
      onAdd(finalData);
      onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-orange-600 via-amber-700 to-yellow-700 p-6 flex justify-between items-center rounded-t-2xl">
          <div className="flex items-center space-x-3">
            <FaCar className="text-white w-7 h-7" />
            <h3 className="text-white text-xl font-bold">{editingItem ? 'Edit Car Rental' : 'Car Rental'}</h3>
          </div>
          <button onClick={onClose} className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-lg">
            <FaTimes />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6 bg-gray-50">
          {/* Search Form */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Pickup Location *</label>
              <input
                type="text"
                value={formData.pickupLocation}
                onChange={(e) => setFormData({ ...formData, pickupLocation: e.target.value })}
                className="w-full px-3 py-2 border rounded-lg"
              />
              {errors.pickupLocation && (
                <p className="text-red-500 text-sm mt-1">{errors.pickupLocation}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Drop-off Location *</label>
              <input
                type="text"
                value={formData.dropoffLocation}
                onChange={(e) => setFormData({ ...formData, dropoffLocation: e.target.value })}
                className="w-full px-3 py-2 border rounded-lg"
              />
              {errors.dropoffLocation && (
                <p className="text-red-500 text-sm mt-1">{errors.dropoffLocation}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Pickup Date *</label>
              <input
                type="datetime-local"
                value={formData.pickupDate}
                onChange={(e) => setFormData({ ...formData, pickupDate: e.target.value })}
                className="w-full px-3 py-2 border rounded-lg"
              />
              {errors.pickupDate && (
                <p className="text-red-500 text-sm mt-1">{errors.pickupDate}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Drop-off Date *</label>
              <input
                type="datetime-local"
                value={formData.dropoffDate}
                onChange={(e) => setFormData({ ...formData, dropoffDate: e.target.value })}
                className="w-full px-3 py-2 border rounded-lg"
              />
              {errors.dropoffDate && (
                <p className="text-red-500 text-sm mt-1">{errors.dropoffDate}</p>
              )}
            </div>
          </div>

          <button
            onClick={handleSearch}
            disabled={searching}
            className="bg-orange-600 text-white py-2 px-4 rounded-lg mt-2 hover:bg-orange-700"
          >
            {searching ? 'Searching...' : 'Search Cars'}
          </button>

          {/* Available Cars */}
          {availableCars.length > 0 && (
            <div className="mt-4">
              <h4 className="text-gray-700 font-semibold mb-2">Available Cars</h4>
              <div className="space-y-2 max-h-64 overflow-y-auto">
                {availableCars.map((car) => (
                  <div
                    key={car.id}
                    onClick={() => handleSelectCar(car)}
                    className={`p-3 border rounded-lg cursor-pointer flex justify-between items-center ${
                      selectedCar?.id === car.id ? 'border-orange-500 bg-orange-50' : 'border-gray-200 hover:bg-gray-100'
                    }`}
                  >
                    <div>
                      <p className="font-semibold">{car.name}</p>
                      <p className="text-sm text-gray-500">{car.company} - {car.carType}</p>
                    </div>
                    <p className="font-semibold">${car.price}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 flex gap-4 border-t border-gray-200">
          <button
            onClick={handleSubmit}
            disabled={isSubmitting || !selectedCar}
            className="flex-1 bg-gradient-to-r from-orange-600 via-amber-700 to-yellow-700 text-white py-3 rounded-lg font-semibold hover:scale-105 transition-transform disabled:opacity-50"
          >
            {isSubmitting ? 'Processing...' : 'Add Car Rental'}
          </button>
          <button
            onClick={onClose}
            className="flex-1 bg-gray-100 py-3 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarModal;
